import { API_URL } from '../config.js';

async function req(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 204) return null;
  const data = await res.json().catch(() => null);
  if (!res.ok) throw (data?.detail ?? { error_code: 'UNKNOWN' });
  return data;
}

export const social = {
  listFriends:    ()              => req('/api/friends'),
  listRequests:   ()              => req('/api/friends/requests'),
  sendRequest:    (name)          => req('/api/friends/request', { method: 'POST', body: { name } }),
  respond:        (request_id, accept) => req('/api/friends/respond', { method: 'POST', body: { request_id, accept } }),
  removeFriend:   (friendId)      => req(`/api/friends/${friendId}`, { method: 'DELETE' }),
  visit:          (hostId)        => req(`/api/players/${hostId}/visit`),
  help:           (hostId, op)    => req(`/api/players/${hostId}/farm/help`, { method: 'POST', body: op }),   // farm 5
  sendFuelGift:   (friendId)      => req(`/api/friends/${friendId}/fuel-gift`, { method: 'POST' }),
};
